
import { Message } from 'view-ui-plus';
export default {
    // sessionStorage
    setSessionStorage: function(key, obj){
        sessionStorage.setItem(key, JSON.stringify(obj));
    },
    getSessionStorage: function(key){
        const str = sessionStorage.getItem(key);
        if(str && str != "undefined" && str != "null"){
            return JSON.parse(str);
        }
        return null;
    },
    removeSessionStorage: function(key){
        sessionStorage.removeItem(key);
    },
    // localStorage
    setLocalStorage: function(key, obj){
        localStorage.setItem(key, JSON.stringify(obj));
    },
    getLocalStorage: function(key){
        const str = localStorage.getItem(key);
        if(str && str != "undefined" && str != "null"){
            return JSON.parse(str);
        }
        return null;
    },
    removeLocalStorage: function(key){
        localStorage.removeItem(key);
    },
    // 获取当前登录token
    getToken(){
        const userInfo = this.getLocalStorage('userInfo');
        if(userInfo){
            return userInfo.token;
        }
        return null;
    },
    // 下载文件, 可以解决跨域不能指定文件名称问题
    downloadfile(url, fileName){
        const x = new window.XMLHttpRequest();
        x.open('GET', url, true);
        x.setRequestHeader('token', this.getToken());
        x.responseType = 'blob';
        x.onload = () => {
            if(x.status === 200){
                const url = window.URL.createObjectURL(x.response);
                const a = document.createElement('a');
                a.href = url;
                a.download = fileName;
                a.click();
            }else{
                Message.error('文件下载失败')
            }
        };
        x.send();
    },
    // hex转rgb
    hexToRgb(hex) {
        let r = parseInt(hex.slice(1, 3), 16);
        let g = parseInt(hex.slice(3, 5), 16);
        let b = parseInt(hex.slice(5, 7), 16);
        return `rgb(${r}, ${g}, ${b})`;
    },
    // hex转rgba
    hexToRgba(hex, a) {
        let r = parseInt(hex.slice(1, 3), 16);
        let g = parseInt(hex.slice(3, 5), 16);
        let b = parseInt(hex.slice(5, 7), 16);
        return `rgba(${r}, ${g}, ${b}, ${a})`;
    },
    // 数字转中文单位
    numberFormatWithChineseUnit(value){
        const obj = {};
        let k = 10000;
        let unit = ['', '万', '亿', '万亿', '兆', '万兆', '亿兆']
        if(value < k){
            obj.value = Math.floor(value * 10) / 10;
            obj.unit = '';
        }else{
            let i = Math.floor(Math.log(value) / Math.log(k));
            obj.value =  Math.floor((value / Math.pow(k, i)) * 10) / 10;
            obj.unit = unit[i];
        }
        return obj;
    },
}
